import SVGAverage from 'thememissmiusvg/average.svg?inline';
import SVGBag from 'thememissmiusvg/bag.svg?inline';
import SVGBigCircleChevronDown from 'thememissmiusvg/big-circle-chevron-down.svg?inline';
import SVGCash from 'thememissmiusvg/cash.svg?inline';
import SVGCategoryAll from 'thememissmiusvg/category-all.svg?inline';
import SVGCategoryAngrychicken from 'thememissmiusvg/category-angrychicken.svg?inline';
import SVGCategoryBeer from 'thememissmiusvg/category-beer.svg?inline';
import SVGCategoryBurgersDouble from 'thememissmiusvg/category-burgers-double.svg?inline';
import SVGCategoryBurgersSaucy from 'thememissmiusvg/category-burgers-saucy.svg?inline';
import SVGCategoryBurgers from 'thememissmiusvg/category-burgers.svg?inline';
import SVGCategoryButcher from 'thememissmiusvg/category-butcher.svg?inline';
import SVGCategoryChicken from 'thememissmiusvg/category-chicken.svg?inline';
import SVGCategoryCocktailLong from 'thememissmiusvg/category-cocktail-long.svg?inline';
import SVGCategoryCocktailMedium from 'thememissmiusvg/category-cocktail-medium.svg?inline';
import SVGCategoryCocktailShort from 'thememissmiusvg/category-cocktail-short.svg?inline';
import SVGCategoryCoffee from 'thememissmiusvg/category-coffee.svg?inline';
import SVGCategoryComboButcher from 'thememissmiusvg/category-combo-butcher.svg?inline';
import SVGCategoryComboNegishi from 'thememissmiusvg/category-combo-negishi.svg?inline';
import SVGCategoryComboNooch from 'thememissmiusvg/category-combo-nooch.svg?inline';
import SVGCategoryComboPoke from 'thememissmiusvg/category-combo-poke.svg?inline';
import SVGCategoryCurries from 'thememissmiusvg/category-curries.svg?inline';
import SVGCategoryDessert from 'thememissmiusvg/category-dessert.svg?inline';
import SVGCategoryDrinks from 'thememissmiusvg/category-drinks.svg?inline';
import SVGCategoryDumplingbrothers from 'thememissmiusvg/category-dumplingbrothers.svg?inline';
import SVGCategoryDumplings from 'thememissmiusvg/category-dumplings.svg?inline';
import SVGCategoryExtras from 'thememissmiusvg/category-extras.svg?inline';
import SVGCategoryFavorites from 'thememissmiusvg/category-favorites.svg?inline';
import SVGCategoryFries from 'thememissmiusvg/category-fries.svg?inline';
import SVGCategoryHouseCraftDrink from 'thememissmiusvg/category-house-craft-drink.svg?inline';
import SVGCategoryKoreanFavorites from 'thememissmiusvg/category-korean-favorites.svg?inline';
import SVGCategoryLolaskitchen from 'thememissmiusvg/category-lolaskitchen.svg?inline';
import SVGCategoryLunchNegishi from 'thememissmiusvg/category-lunch-negishi.svg?inline';
import SVGCategoryLunchNooch from 'thememissmiusvg/category-lunch-nooch.svg?inline';
import SVGCategoryMissmiu from 'thememissmiusvg/category-missmiu.svg?inline';
import SVGCategoryNegishi from 'thememissmiusvg/category-negishi.svg?inline';
import SVGCategoryNooch from 'thememissmiusvg/category-nooch.svg?inline';
import SVGCategoryOutbacklodge from 'thememissmiusvg/category-outbacklodge.svg?inline';
import SVGCategoryPokeBowls from 'thememissmiusvg/category-poke-bowls.svg?inline';
import SVGCategoryPokenation from 'thememissmiusvg/category-pokenation.svg?inline';
import SVGCategoryRiceDish from 'thememissmiusvg/category-rice-dish.svg?inline';
import SVGCategorySalads from 'thememissmiusvg/category-salads.svg?inline';
import SVGCategorySauce from 'thememissmiusvg/category-sauce.svg?inline';
import SVGCategorySlides from 'thememissmiusvg/category-slides.svg?inline';
import SVGCategorySoupNoodles from 'thememissmiusvg/category-soup-noodles.svg?inline';
import SVGCategorySoup from 'thememissmiusvg/category-soup.svg?inline';
import SVGCategorySpecial from 'thememissmiusvg/category-special.svg?inline';
import SVGCategorySpeed from 'thememissmiusvg/category-speed.svg?inline';
import SVGCategoryStarters from 'thememissmiusvg/category-starters.svg?inline';
import SVGCategorySushiPlates from 'thememissmiusvg/category-sushi-plates.svg?inline';
import SVGCategorySushi from 'thememissmiusvg/category-sushi.svg?inline';
import SVGCategoryTea from 'thememissmiusvg/category-tea.svg?inline';
import SVGCategoryVegan from 'thememissmiusvg/category-vegan.svg?inline';
import SVGCategoryVegi from 'thememissmiusvg/category-vegi.svg?inline';
import SVGCategoryWine from 'thememissmiusvg/category-wine.svg?inline';
import SVGCheckmark from 'thememissmiusvg/checkmark.svg?inline';
import SVGCircleChevronDown from 'thememissmiusvg/circle-chevron-down.svg?inline';
import SVGCircleChevronLeft from 'thememissmiusvg/circle-chevron-left.svg?inline';
import SVGCircleChevronRight from 'thememissmiusvg/circle-chevron-right.svg?inline';
import SVGCircleChevronUp from 'thememissmiusvg/circle-chevron-up.svg?inline';
import SVGCircleMinus from 'thememissmiusvg/circle-minus.svg?inline';
import SVGCirclePlay from 'thememissmiusvg/circle-play.svg?inline';
import SVGCirclePlus from 'thememissmiusvg/circle-plus.svg?inline';
import SVGClock from 'thememissmiusvg/clock.svg?inline';
import SVGClose from 'thememissmiusvg/close.svg?inline';
import SVGCreditCard from 'thememissmiusvg/credit-card.svg?inline';
import SVGCross from 'thememissmiusvg/cross.svg?inline';
import SVGDate from 'thememissmiusvg/date.svg?inline';
import SVGDelivery from 'thememissmiusvg/delivery.svg?inline';
import SVGDeliveryman from 'thememissmiusvg/deliveryman.svg?inline';
import SVGDishBowl from 'thememissmiusvg/dish-bowl.svg?inline';
import SVGDuplicate from 'thememissmiusvg/duplicate.svg?inline';
import SVGEdit from 'thememissmiusvg/edit.svg?inline';
import SVGEnvelope from 'thememissmiusvg/envelope.svg?inline';
import SVGFilterDessert from 'thememissmiusvg/filter-dessert.svg?inline';
import SVGFilterVegan from 'thememissmiusvg/filter-vegan.svg?inline';
import SVGFilterVegi from 'thememissmiusvg/filter-vegi.svg?inline';
import SVGFilter from 'thememissmiusvg/filter.svg?inline';
import SVGIndiningMenu from 'thememissmiusvg/indining-menu.svg?inline';
import SVGIndining from 'thememissmiusvg/indining.svg?inline';
import SVGInfo from 'thememissmiusvg/info.svg?inline';
import SVGLocation from 'thememissmiusvg/location.svg?inline';
import SVGMap from 'thememissmiusvg/map.svg?inline';
import SVGMenuAllergens from 'thememissmiusvg/menu-allergens.svg?inline';
import SVGMenuDrinks from 'thememissmiusvg/menu-drinks.svg?inline';
import SVGMenuInformation from 'thememissmiusvg/menu-information.svg?inline';
import SVGMenuKids from 'thememissmiusvg/menu-kids.svg?inline';
import SVGMenuLunch from 'thememissmiusvg/menu-lunch.svg?inline';
import SVGMenuSushi from 'thememissmiusvg/menu-sushi.svg?inline';
import SVGMenu from 'thememissmiusvg/menu.svg?inline';
import SVGMidCircleChevronDown from 'thememissmiusvg/mid-circle-chevron-down.svg?inline';
import SVGMidCircleChevronLeft from 'thememissmiusvg/mid-circle-chevron-left.svg?inline';
import SVGMidCircleChevronRight from 'thememissmiusvg/mid-circle-chevron-right.svg?inline';
import SVGMidCircleChevronUp from 'thememissmiusvg/mid-circle-chevron-up.svg?inline';
import SVGPhone from 'thememissmiusvg/phone.svg?inline';
import SVGPlateCutlery from 'thememissmiusvg/plate-cutlery.svg?inline';
import SVGReserve from 'thememissmiusvg/reserve.svg?inline';
import SVGReset from 'thememissmiusvg/reset.svg?inline';
import SVGSettings from 'thememissmiusvg/settings.svg?inline';
import SVGSmallAverage from 'thememissmiusvg/small-average.svg?inline';
import SVGSmallCheckmark from 'thememissmiusvg/small-checkmark.svg?inline';
import SVGSmallChevronDown from 'thememissmiusvg/small-chevron-down.svg?inline';
import SVGSmallChevronUp from 'thememissmiusvg/small-chevron-up.svg?inline';
import SVGSmallCircleFull from 'thememissmiusvg/small-circle-full.svg?inline';
import SVGSmallCircle from 'thememissmiusvg/small-circle.svg?inline';
import SVGSmallClose from 'thememissmiusvg/small-close.svg?inline';
import SVGSmallCross from 'thememissmiusvg/small-cross.svg?inline';
import SVGSmallLink from 'thememissmiusvg/small-link.svg?inline';
import SVGSpeechBubble from 'thememissmiusvg/speech-bubble.svg?inline';
import SVGStarFilledHalf from 'thememissmiusvg/star-filled-half.svg?inline';
import SVGStarFilled from 'thememissmiusvg/star-filled.svg?inline';
import SVGStarHalf from 'thememissmiusvg/star-half.svg?inline';
import SVGStar from 'thememissmiusvg/star.svg?inline';
import SVGTakeaway from 'thememissmiusvg/takeaway.svg?inline';
import SVGTrash from 'thememissmiusvg/trash.svg?inline';
import SVGUser from 'thememissmiusvg/user.svg?inline';
import SVGUsers from 'thememissmiusvg/users.svg?inline';
import SVGWarning from 'thememissmiusvg/warning.svg?inline';

export default {
	SVGAverage,
	SVGBag,
	SVGBigCircleChevronDown,
	SVGCash,
	SVGCategoryAll,
	SVGCategoryAngrychicken,
	SVGCategoryBeer,
	SVGCategoryBurgersDouble,
	SVGCategoryBurgersSaucy,
	SVGCategoryBurgers,
	SVGCategoryButcher,
	SVGCategoryChicken,
	SVGCategoryCocktailLong,
	SVGCategoryCocktailMedium,
	SVGCategoryCocktailShort,
	SVGCategoryCoffee,
	SVGCategoryComboButcher,
	SVGCategoryComboNegishi,
	SVGCategoryComboNooch,
	SVGCategoryComboPoke,
	SVGCategoryCurries,
	SVGCategoryDessert,
	SVGCategoryDrinks,
	SVGCategoryDumplingbrothers,
	SVGCategoryDumplings,
	SVGCategoryExtras,
	SVGCategoryFavorites,
	SVGCategoryFries,
	SVGCategoryHouseCraftDrink,
	SVGCategoryKoreanFavorites,
	SVGCategoryLolaskitchen,
	SVGCategoryLunchNegishi,
	SVGCategoryLunchNooch,
	SVGCategoryMissmiu,
	SVGCategoryNegishi,
	SVGCategoryNooch,
	SVGCategoryOutbacklodge,
	SVGCategoryPokeBowls,
	SVGCategoryPokenation,
	SVGCategoryRiceDish,
	SVGCategorySalads,
	SVGCategorySauce,
	SVGCategorySlides,
	SVGCategorySoupNoodles,
	SVGCategorySoup,
	SVGCategorySpecial,
	SVGCategorySpeed,
	SVGCategoryStarters,
	SVGCategorySushiPlates,
	SVGCategorySushi,
	SVGCategoryTea,
	SVGCategoryVegan,
	SVGCategoryVegi,
	SVGCategoryWine,
	SVGCheckmark,
	SVGCircleChevronDown,
	SVGCircleChevronLeft,
	SVGCircleChevronRight,
	SVGCircleChevronUp,
	SVGCircleMinus,
	SVGCirclePlay,
	SVGCirclePlus,
	SVGClock,
	SVGClose,
	SVGCreditCard,
	SVGCross,
	SVGDate,
	SVGDelivery,
	SVGDeliveryman,
	SVGDishBowl,
	SVGDuplicate,
	SVGEdit,
	SVGEnvelope,
	SVGFilterDessert,
	SVGFilterVegan,
	SVGFilterVegi,
	SVGFilter,
	SVGIndiningMenu,
	SVGIndining,
	SVGInfo,
	SVGLocation,
	SVGMap,
	SVGMenuAllergens,
	SVGMenuDrinks,
	SVGMenuInformation,
	SVGMenuKids,
	SVGMenuLunch,
	SVGMenuSushi,
	SVGMenu,
	SVGMidCircleChevronDown,
	SVGMidCircleChevronLeft,
	SVGMidCircleChevronRight,
	SVGMidCircleChevronUp,
	SVGPhone,
	SVGPlateCutlery,
	SVGReserve,
	SVGReset,
	SVGSettings,
	SVGSmallAverage,
	SVGSmallCheckmark,
	SVGSmallChevronDown,
	SVGSmallChevronUp,
	SVGSmallCircleFull,
	SVGSmallCircle,
	SVGSmallClose,
	SVGSmallCross,
	SVGSmallLink,
	SVGSpeechBubble,
	SVGStarFilledHalf,
	SVGStarFilled,
	SVGStarHalf,
	SVGStar,
	SVGTakeaway,
	SVGTrash,
	SVGUser,
	SVGUsers,
	SVGWarning
}
